import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { SharedserviceService } from 'src/app/services/sharedservice.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  user:any = JSON.parse(localStorage.getItem("userAgency_dealfare"));
  user_type:any;
  name:any;
  id:any;
  clientprofile: FormGroup;
  selectCountry:any="Country";
  selectstate:any='State';
  selectcity:any='City';
  profile:any;
  country_name:any;
  constructor(private activatedRoute: ActivatedRoute, private fb: FormBuilder, public httpClient: SharedserviceService, public router: Router,private toastr:ToastrManager) {
    //this.id = this.activatedRoute.snapshot.paramMap.get("id");
    //this.client_id = this.activatedRoute.snapshot.paramMap.get("id");
    //this.user.jwt="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjo1LCJ1c2VyX2VtYWlsIjoidGVzdDJAZ21haWwuY29tIiwidHlwZSI6ImN1c3RvbWVycyJ9.krOysYurlj4bu4swegrU92AzmuIAmE0cRhvAyJ-YqNw";
    if(this.user != null){
      this.id = this.user.id;
      this.user_type = this.user.role_id;
      this.name = this.user.name;
    }
    this.Profile();
    this.country();
  }

  ngOnInit() {
    this.clientprofile = this.fb.group({
      user_id:[null],
      name:[null],
      email:[null],
      mobile:[null],
      phone:[null],
      password:[null],
      address:[null],
      address_2:[null],
      city:[null],
      state:[null],
      country_id:[null],
      zipcode:[null],
      company_name:[null],
      website:[null],
      gst_no:[null],
      pan_no:[null],
      gst_doc:[null],
      pan_doc:[null],
    });
  }

  editProfile(){
    
    //alert(JSON.stringify(this.clientprofile.value));
    this.httpClient.loadingShow = true;
    this.clientprofile.patchValue({user_id:this.id});
    this.httpClient.post('editProfile',this.clientprofile.value).subscribe((res)=> {
    this.httpClient.loadingShow = false;
      if(res.success == 'success') { 
        alert('profile edit successfully');
      }
    },err=>{
      this.toastr.errorToastr(err.error.replyMsg,"Error")
    });
  }


  Profile(){
    const self = this;
    //this.httpClient.auth_token = this.user.jwt;
    self.httpClient.loadingShow = true;
    
    var userid = {
      'user_id' : this.id,
    }

    this.httpClient.post('profile', userid).subscribe(function (res) {
    self.httpClient.loadingShow = false;
    
     if (res.data) {
         self.profile = res.data;
         
         self.clientprofile.patchValue({
          
         id:res.data.id,
         name:res.data.name,
         email:res.data.email,
         mobile:res.data.mobile,
         phone:res.data.phone,
         password:res.data.password,
         address:res.data.address,
         address_2:res.data.address_2,
         city:res.data.city,
         state:res.data.state,
         country_id:res.data.country_id,
         zipcode:res.data.zipcode,
         company_name:res.data.company_name,
         website:res.data.website,
         gst_no:res.data.gst_no,
         pan_no:res.data.pan_no,
         gst_doc:res.data.gst_doc,
         pan_doc:res.data.pan_doc,
       });
      }
    });
  
  }

  country(){
    const self = this;
    this.httpClient.post('country', null).subscribe(function (res) {
      self.httpClient.loadingShow = false;
      if (res.data) {
        self.country_name = res.data;
        
//console.log(self.country_name);
      }
    })
       
  }

}

